import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearNativeWebsite } from './nativeShell';
import { MOBILE_APP_BACK_LABEL } from './appBranding';

const barStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 2000,
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  minHeight: 56,
  padding: '10px 16px',
  background: '#14171c',
  color: '#fff',
};

const buttonStyle = {
  minHeight: 44,
  padding: '8px 14px',
  border: 0,
  borderRadius: 10,
  background: '#c62828',
  color: '#fff',
  fontWeight: 700,
};

/**
 * Shown on website routes inside the LGL Portal APK so NDE / Testing /
 * Time Tracker / Coding Structure / Open full website never dump the
 * superintendent into Chrome, and they can get back to /m without the
 * after-login bounce trapping them.
 */
export const NativeWebsiteBar = () => {
  const navigate = useNavigate();
  return (
    <div role="navigation" aria-label={MOBILE_APP_BACK_LABEL} style={barStyle}>
      <button
        type="button"
        style={buttonStyle}
        onClick={() => {
          clearNativeWebsite();
          navigate('/m');
        }}
      >
        {MOBILE_APP_BACK_LABEL}
      </button>
      <span style={{ fontSize: 13, opacity: 0.85 }}>
        Website view — stays in this app.
      </span>
    </div>
  );
};
